import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/lib/i18n";

export const CookieBanner = () => {
  const { t } = useLang();
  const [show, setShow] = useState(() => !localStorage.getItem("mx_cookies"));
  const choose = (v) => { localStorage.setItem("mx_cookies", v); setShow(false); };
  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="cookie-banner" initial={{ y: 120, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 120, opacity: 0 }} transition={{ delay: 3, duration: 0.7 }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] bg-midnight/95 backdrop-blur-xl border border-gold/30 p-6 text-ivory">
          <p className="text-sm text-ivory/85 leading-relaxed">{t.cookie.text} <Link to="/cookies" className="text-gold underline underline-offset-4">{t.cookie.more}</Link></p>
          <div className="mt-5 flex gap-3">
            <button data-testid="cookie-accept" onClick={() => choose("all")} className="btn-gold flex-1">{t.cookie.accept}</button>
            <button data-testid="cookie-necessary" onClick={() => choose("necessary")} className="btn-ghost flex-1">{t.cookie.necessary}</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
